module.exports = __webpack_public_path__ + "img/eyes_male_extra_round.9aaf9d73.png";